import { matchPath, match } from "react-router-dom";
import { MainNavMenuAsButton, MainNavMenuLink, Pill } from "@compono/ui";
import { ShowIf, useIsTalentRestricted } from "~/auth-layer";
import { useHireJobRequisitionsFlag } from "~/hooks/useHireJobRequisitionsFlag";
import { useHireOfferManagementFlag } from "~/hooks/useHireOfferManagementFlag";
import { useRequisitionWorkflowEnabled } from "~/hooks/useRequisitionWorkflowEnabled";

import useFetchCounts from "~/../trackyr-ui/src/features/Messages/useFetchCounts";

import { PortalOutlineIcon } from "../icons/PortalOutlineIcon";

export const HireNav = () => {
  const { counts } = useFetchCounts();
  const { unread } = counts || { unread: 0 };
  const isReadOnly = useIsTalentRestricted();
  // Requisitions shows when the LD flag is on, the org's Approval
  // Configuration toggle is on, and the user has the jobRequisitions role.
  const requisitionWorkflowEnabled = useRequisitionWorkflowEnabled();
  const hireJobRequisitions = useHireJobRequisitionsFlag();
  // The Approvals inbox is shared with Approval to Hire, so offers keep it
  // reachable while the requisition workflow toggle is off. With offers off the
  // toggle alone governs it, as it did before offers existed.
  const hireOfferManagement = useHireOfferManagementFlag();

  return (
    <MainNavMenuAsButton
      icon={PortalOutlineIcon}
      label="Hire"
      data-menu-button="true"
      notify={unread ? true : false}
    >
      <MainNavMenuLink
        data-testid="side-nav-jobs-main-nav-link"
        exact
        href="/"
        label="Jobs"
        data-is-active={(match: match, location: Location) =>
          !!match ||
          !!matchPath(location.pathname, {
            path: "/organisation/:orgId/listing/:listingId",
            exact: false,
          })
        }
      />
      {!isReadOnly && (
        <MainNavMenuLink
          data-testid="side-nav-talents-main-nav-link"
          href="/talent"
          label="Talent"
        />
      )}
      <ShowIf allowedTo="applicationMessages.view">
        <MainNavMenuLink
          data-testid="side-nav-messages-main-nav-link"
          href="/messages"
          label="Messages"
          decor={
            unread ? (
              <Pill tone="critical" sx={{ ml: 3 }}>
                {unread}
              </Pill>
            ) : (
              ""
            )
          }
          notify={unread ? "onNavCollapsed" : false}
        />
      </ShowIf>
      <MainNavMenuLink
        data-testid="side-nav-interviews-main-nav-link"
        href="/interviews"
        label="Interviews"
      />
      {requisitionWorkflowEnabled && (
        <ShowIf allowedTo="jobRequisitions.view">
          <MainNavMenuLink
            data-testid="side-nav-requisitions-main-nav-link"
            href="/requisitions"
            label="Requisitions"
          />
        </ShowIf>
      )}
      {hireJobRequisitions &&
        (requisitionWorkflowEnabled || hireOfferManagement) && (
          <ShowIf allowedTo="jobRequisitions.viewApprovals">
            <MainNavMenuLink
              data-testid="side-nav-approvals-main-nav-link"
              href="/approvals"
              label="Approvals"
            />
          </ShowIf>
        )}
      <ShowIf allowedTo="teams.view">
        <MainNavMenuLink href={`/teams`} label="Hiring teams" />
      </ShowIf>
    </MainNavMenuAsButton>
  );
};
